<template>
    <ul class="order-list">
        <li class="order-items order-title" v-if="!index">
            <div class="creat_time">缴费时间</div>
            <div class="pay_type">缴费项目</div>
            <div class="pay_money">金额</div>
        </li>
    </ul>
    <ul class="order-list" v-if="orderLst.length" :style="!index?{'margin-top': '15px'}:''">
        <li class="order-items" v-for="order in orderLst" :key="order.id">
            <div class="creat_time">{{ order.create_time }}</div>
            <div class="pay_type">{{ order.typeItems.name }}</div>
            <div class="pay_money">{{ parseFloat(order.amount) }}元</div>
        </li>
    </ul>
    <el-empty v-else description="暂时没有订单" :image-size="80"/>
    <el-divider v-if="orderLst.length && page >= lastPage && !index">
        到底了
    </el-divider>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, watch} from "vue";
import axiosApi from "@/utils/axiosApi";
import store from "@/store";
import {_message} from "@/utils/func";

const prop = defineProps({
    index: {
        type: Boolean,
        default: () => false
    }
})
const orderLst = ref([])
const page = ref(1)
const lastPage = ref(0)
const getOrder = () => {
    new axiosApi({
        encode: "bm",
        method: "user/pay_details",
        body: {
            member_id: account.value.cust_id,
            page: page.value
        }
    }).send(res => {
        if (res.message.code !== "000") return _message(res.message.content)
        if (prop.index) {
            orderLst.value = res.data.data.filter((its, inx) => inx < 3)
        } else {
            if (page.value === 1) {
                orderLst.value = res.data.data
            } else {
                orderLst.value = orderLst.value.concat(res.data.data)
            }
            lastPage.value = res.data.last_page
        }

    })
}
const account = computed(() => store.state.account)
watch(account, (to) => {
    // console.log(to,from)
    if (orderLst.value.length < 1 && to.cust_id) {
        getOrder()
    }
})

const onBottom = () => {
    let clientHeight = document.documentElement.clientHeight
    let scrollTop = document.documentElement.scrollTop
    let scrollHeight = document.documentElement.scrollHeight
    if (clientHeight + scrollTop > scrollHeight - 100) {
        if (page.value < lastPage.value) {
            page.value++
            getOrder()
        }
    }
}

const listenBottom = () => {
    window.addEventListener("scroll", onBottom)
}
onMounted(() => {
    orderLst.value = []
    page.value = 1
    lastPage.value = 1
    store.commit("getAccount")
    if (!prop.index)
        listenBottom()
})
</script>

<style lang="less" scoped>
.order-items {
  display: flex;
  align-items: center;
  line-height: 1.75;
  padding-bottom: 10px;
  font-size: 14px;

  &.order-title {
    font-weight: 600;
    border-bottom: 1px solid #D4D4D4;
  }

  .creat_time {
    width: 55%;
  }

  .pay_type {
    width: 20%;
  }

  .pay_money {
    width: 30%;
    text-align: right;
  }

  & + .order-items {
    padding-top: 10px;
  }
}
</style>
